type DatedItem = {
  date: string | null;
};

/**
 * Converts a date string into an epoch timestamp or negative infinity if invalid.
 */
function toTimestamp(value: string | null): number {
  if (!value) return Number.NEGATIVE_INFINITY;
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? Number.NEGATIVE_INFINITY : parsed;
}

/**
 * Sorts items in descending chronological order (newest first).
 * Preserves original index order when timestamps are equal.
 *
 * @param items List of dated items
 * @returns Sorted array
 */
export function sortByNewest<T extends DatedItem>(items: T[]): T[] {
  return items
    .map((item, index) => ({ item, index, ts: toTimestamp(item.date) }))
    .sort((a, b) => {
      if (a.ts !== b.ts) return b.ts - a.ts;
      return b.index - a.index;
    })
    .map((entry) => entry.item);
}
